/** Job titles as parties write them on powers of attorney and filings, in both languages. Unknown titles are shown as written. */
const TITLES: ReadonlyArray<readonly [string, string]> = [
  ["Managing Director", "العضو المنتدب"],
  ["General Manager", "المدير العام"],
  ["Chief Executive Officer", "الرئيس التنفيذي"],
  ["CEO", "الرئيس التنفيذي"],
  ["Chief Financial Officer", "المدير المالي"],
  ["Finance Director", "المدير المالي"],
  ["Chairman", "رئيس مجلس الإدارة"],
  ["Chairman of the Board", "رئيس مجلس الإدارة"],
  ["Board Member", "عضو مجلس الإدارة"],
  ["Director", "مدير"],
  ["Partner", "شريك"],
  ["Managing Partner", "الشريك المدير"],
  ["Legal Counsel", "المستشار القانوني"],
  ["General Counsel", "المستشار القانوني العام"],
  ["Head of Legal", "رئيس الشؤون القانونية"],
  ["Company Secretary", "أمين سر الشركة"],
  ["Authorised Signatory", "المفوض بالتوقيع"],
  ["Compliance Officer", "مسؤول الامتثال"],
  ["Judicial Officer", "مأمور الضبط القضائي"],
  ["Economic Expert", "خبير اقتصادي"],
  ["Economic Researcher", "باحث اقتصادي"],
  ["Legal Expert", "خبير قانوني"],
  ["Legal Researcher", "باحث قانوني"],
  ["Store Manager", "مدير المتجر"],
  ["Sales Director", "مدير المبيعات"],
  ["Sales Manager", "مدير المبيعات"],
];

const TO_AR = new Map(TITLES.map(([en, ar]) => [en.toLowerCase(), ar]));
const TO_EN = new Map(TITLES.map(([en, ar]) => [ar, en]));

export function jobTitleText(title: string | null | undefined, locale: string): string {
  const t = (title ?? "").trim();
  if (!t) return "";
  return locale.startsWith("ar") ? TO_AR.get(t.toLowerCase()) ?? t : TO_EN.get(t) ?? t;
}
